<script>import { createEventDispatcher, getContext } from "svelte";
import { formReset } from "../../../actions/formReset.js";
const _browser = typeof window !== "undefined";
export let contextKey;
export const api = {
  focus: () => {
    $focus = true;
    if (inputElem && $disabled === false && document.activeElement !== inputElem) {
      inputElem.focus();
    }
  }
};
const dispatch = createEventDispatcher();
let inputElem;
const ctx = getContext(contextKey);
let { name, empty, dirty, focus, visited, disabled, value, activity } = ctx;
let displayValue = ctx.detail;
let initialValue = $value;
let state = {
  empty: $empty,
  dirty: $dirty,
  focus: $focus,
  visited: $visited,
  disabled: $disabled
};
$: {
  $empty = $value === void 0;
  $dirty = !$disabled ? ($value !== void 0 || !initialValue != void 0) && $value !== initialValue : false;
  $focus = !$disabled ? $focus : false;
  $visited = !$disabled ? $visited : false;
  let changes = {};
  if ($empty != state.empty) {
    changes.empty = $empty;
  }
  if ($dirty != state.dirty) {
    changes.dirty = $dirty;
  }
  if ($focus != state.focus) {
    changes.focus = $focus;
  }
  if ($visited != state.visited) {
    changes.visited = $visited;
  }
  state = { empty: $empty, dirty: $dirty, focus: $focus, visited: $visited, disabled: $disabled };
  if (Object.keys(changes).length > 0) {
    dispatch("state", { changes, state });
  }
}
const onDisplayInputEvent = (ev) => {
  const elem = ev.target ? ev.target : void 0;
  if (elem) {
    dispatch("input", {
      name,
      value: elem.value
    });
  }
};
let closingTimer = void 0;
$: {
  if ($activity === true && closingTimer !== void 0) {
    if (_browser) {
      window.clearTimeout(closingTimer);
    }
    closingTimer = void 0;
  }
  $activity = false;
}
const inputLostFocus = () => {
  if (_browser) {
    closingTimer = window.setTimeout(() => {
      closingTimer = void 0;
      $activity = false;
      $focus = false;
    }, 250);
  }
};
</script>

<input {name} use:formReset style="display:none;" type="text" bind:value={$value} />
<input
	type="text"
	use:formReset
	value={$displayValue ?? ''}
	bind:this={inputElem}
	disabled={$disabled}
	autocomplete="off"
	on:focus={() => {
		$visited = true;
		$focus = true;
	}}
	on:blur={() => {
		inputLostFocus();
	}}
	on:input={onDisplayInputEvent}
/>
